import React from 'react';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

import { AppTable, AppTableColumn } from '../../table/appTable';
import Button from '../../buttons/button';
import { createLink } from '../utils/link-builder';

import { EditChapterFormDataProps, ChapterActionButtonsProps, ChaptersTableProps } from './chapter.types';

const ActionButtons = ({ original, onDelete, onEdit }: ChapterActionButtonsProps) => {
  const { id, orderIndex, chapterType } = original;
  const chapterBasicValues: EditChapterFormDataProps = {
    id,
    orderIndex,
    chapterType,
  };

  return (
    <>
      <Button
        text="Delete Chapter"
        icon={faTrash}
        slimButton
        onClick={e => {
          e.stopPropagation();
          onDelete(original.id);
        }}
      />
      <Button
        text="Edit Chapter"
        icon={faEdit}
        slimButton
        onClick={e => {
          e.stopPropagation();
          onEdit(chapterBasicValues);
        }}
      />
    </>
  );
};

export const ChaptersTable = ({ chapters, isLoading, onClickDelete, onClickEdit }: ChaptersTableProps) => {
  const columns: AppTableColumn[] = [
    {
      Header: '#',
      id: 'orderIndex',
      accessor: 'orderIndex',
      width: 50,
    },
    {
      Header: 'Chapter Type',
      id: 'chapterType',
      accessor: 'chapterType',
      width: 150,
    },
    {
      Header: 'Asset',
      id: 'asset',
      accessor: 'assetUrl',
      width: 300,
      Cell: ({ row }) => createLink(row, 'asset', 'Watch Asset'),
    },
    {
      Header: 'Actions',
      id: 'actions',
      accessor: 'actions',
      width: 300,
      Cell: ({ original }) => <ActionButtons original={original} onDelete={onClickDelete} onEdit={onClickEdit} />,
    },
  ];

  return (
    <AppTable
      columns={columns}
      tableName="chapter-management"
      loading={isLoading}
      data={chapters}
      defaultSorted={[{ id: 'index', desc: false }]}
    />
  );
};
